import { fetchChallenges, fetchMatchData, fetchChampionMastery, fetchSearchHistory, fetchTftMatchHistory } from './endpoints.js'
import { unwrapData, normalizeSearchHistory } from './adapters.js'

export const getChallenges = async (summonerName, region, isUpdate) => {
  const response = await fetchChallenges(summonerName, region, isUpdate)
  return unwrapData(response)
}

export const getMatchData = async (summonerName, region, isUpdate) => {
  const response = await fetchMatchData(summonerName, region, isUpdate)
  return unwrapData(response)
}

export const getChampionMastery = async (summonerName, region, isUpdate) => {
  const response = await fetchChampionMastery(summonerName, region, isUpdate)
  return unwrapData(response)
}

export const getSearchHistory = async () => {
  const response = await fetchSearchHistory()
  return normalizeSearchHistory(unwrapData(response))
}

export const getTftMatchHistory = async (summonerName, region, queue, count) => {
  const response = await fetchTftMatchHistory(summonerName, region, queue, count)
  return unwrapData(response)
}
